import { API, removeBlankAttributes } from "@project/common"
import dayjs from "dayjs"
export interface IReturnDailyBusinessReportList {
  count?: number
  data?: any
}

export interface IDailyBusinessReportListParam {
  page?: string | number
  facility_id?: string
  from_date?: string
  to_date?: string
  date?: string
  pageSize?: number
  year?: number
  month?: number
}

const BASE_ENDPOINT = "daily-business-report"

export const fetchDailyBusinessReportList = async ({
  queryKey,
}): Promise<IReturnDailyBusinessReportList> => {
  const params = {} as IDailyBusinessReportListParam
  params.page = queryKey[1]
  params.pageSize = 20
  params.facility_id = queryKey[2]?.facility_id
  params.from_date = queryKey[2]?.from_date
    ? dayjs(queryKey[2]?.from_date).format("YYYY-MM-DD")
    : null
  params.to_date = queryKey[2]?.to_date
    ? dayjs(queryKey[2]?.to_date).format("YYYY-MM-DD")
    : null
  params.year = queryKey[2]?.year || null
  params.month = queryKey[2]?.month || null

  return API.get(`/${BASE_ENDPOINT}`, {
    params,
  })
}
export const createDailyBusinessReport = async (values): Promise<any> => {
  delete values?.id
  return API.post(`/${BASE_ENDPOINT}`, values)
}
export const updateDailyBusinessReport = async (values) => {
  const id = values.id
  delete values.id
  return API.put(`/${BASE_ENDPOINT}/${id}`, values)
}

export const getDailyBusinessReport = async ({ queryKey }) => {
  const id = queryKey[1]
  return API.get(`/${BASE_ENDPOINT}/${id}`)
}

export const getAllDailyUser = async () => {
  return API.get(`/user`)
}

export const getDailyBusinessReportView = async ({
  queryKey,
}: {
  queryKey?: any
}) => {
  const facility_id = queryKey[1]?.facility
  const from_date = queryKey[2]?.from_date
    ? dayjs(queryKey[2]?.from_date).format("YYYY-MM-DD")
    : null
  const to_date = queryKey[2]?.to_date
    ? dayjs(queryKey[2]?.to_date).format("YYYY-MM-DD")
    : null

  return API.get(
    `/${BASE_ENDPOINT}/${facility_id}?from_date=${from_date}&to_date=${to_date}`,
  )
}

export const deleteDailyBusinessReport = async (id) => {
  return API.delete(`/${BASE_ENDPOINT}/${id}`)
}

export const getAllWork = async () => {
  return API.get(`/work?page=1&pageSize=Infinity`)
}

export const getAllStaff = () => {
  return API.get(`/instructors?page=1&pageSize=Infinity`)
}

export const getDateInfoDetail = async (queries: {
  date?: string
  facilityIds: number
  year?: number
  month?: number
}) => {
  const params = removeBlankAttributes(queries)
  return API.get(`/${BASE_ENDPOINT}/date-info-detail`, {
    params,
  })
}

export const fetchOneDailyBusinessReportList = async ({
  queryKey,
}): Promise<IReturnDailyBusinessReportList> => {
  const params = {} as any
  const id = queryKey[1]
  params.facility_id = queryKey[2]
  return API.get(`/${BASE_ENDPOINT}/${id}`, {
    params,
  })
}

export const fetchDailyBusinessReportListFormDetail = async (values: {
  facilityIds: number
  date: string
  show_next_available?: string
  show_prev_available?: string
}): Promise<IReturnDailyBusinessReportList> => {
  const params = removeBlankAttributes(values)
  return API.get(`/${BASE_ENDPOINT}`, {
    params,
  })
}

// ==== 利用者ごとの業務日報関連のAPI ====

// バッチ取得（事業所・年月・複数ユーザー）
export const fetchUsersMonthlySupportReport = async (params: any) => {
  // queryKey形式と直接オブジェクト形式の両方に対応
  let queries = params
  if (params && params.queryKey) {
    queries = params.queryKey[1] || {}
  }

  const { year, month, user_ids, facility_id, page } = queries
  let userIds = user_ids
  if (Array.isArray(userIds)) userIds = userIds.join(",")

  const apiParams: any = {}
  if (userIds) {
    apiParams.user_ids = userIds
  }
  if (facility_id) {
    apiParams.facility_id = facility_id
  }
  if (page) {
    apiParams.page = page
  }

  if (!year || !month) {
    return { data: [], count: 0 } // APIを呼ばずに空のデータを返す
  }

  const url = `/${BASE_ENDPOINT}/users-monthly/${year}/${month}`

  const result: { data: any; count: number } = await API.get(url, {
    params: apiParams,
  })

  return result
}

// バッチ更新（複数レコード一括更新）
export const updateSupportReportBatch = async (values: any[]): Promise<any> => {
  return API.put(`/${BASE_ENDPOINT}/batch/support-records`, values)
}

// 支援記録一括削除（選択された支援記録を削除）
export const deleteSupportReportBatch = async (
  supportReportIds: number[],
): Promise<any> => {
  return API.delete(`/${BASE_ENDPOINT}/batch/support-records`, {
    data: { support_report_ids: supportReportIds },
  })
}
